/**
 * Gets a thumbnail URL with the specified size
 * @param {string} url - The original thumbnail URL
 * @param {number} size - The desired thumbnail size (both width and height)
 * @returns {string} The thumbnail URL with adjusted size parameters
 */
export function getThumbnailUrl(url, size) {
  if (!url || typeof url !== 'string') return url
  if (typeof size !== 'number' || Number.isNaN(size) || size <= 0) return url

  // Replace the fixed size pattern with the new size
  return url.replace('/small_image/120x/', `/small_image/${size}x/`)
}

export default getThumbnailUrl
